// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module__avatar--9IAhj","avatarInitials":"Avatar-module__avatarInitials--3PLzt","image":"Avatar-module__image--vmDRw"};